
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign",
      function () {
        return require("private-next-pages/campaign.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign"])
      });
    }
  